const adaptData = ({ pages }, location) => {
    const { pathname } = location;
    const parts = pathname.split('/').filter(part => part != '');
    const currentSection = parts[1];

    return {
        pages,
        currentSection
    }
};

export default adaptData;
